module.exports = __webpack_public_path__ + "static/media/cross.c7699743.svg";